import { render } from "./DirectSettings.vue?vue&type=template&id=71410956&scoped=true"
import script from "./DirectSettings.vue?vue&type=script&lang=js"
export * from "./DirectSettings.vue?vue&type=script&lang=js"

import "./DirectSettings.vue?vue&type=style&index=0&id=71410956&scoped=true&lang=css"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71410956"]])

export default __exports__